import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => (
  <motion.a
    data-testid="whatsapp-chat-button"
    href="https://wa.me/919619923347?text=Hi%20ARK%20IT%20ENTERPRISES%2C%20I%20need%20IT%20support."
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with ARK IT ENTERPRISES on WhatsApp"
    initial={{ opacity: 0, scale: 0.5, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.8, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    className="fixed bottom-6 left-6 z-[80] group"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" aria-hidden="true" />
    <span className="relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.4)] group-hover:scale-110 transition-transform duration-300">
      <MessageCircle size={26} className="text-white" fill="currentColor" />
    </span>
    <span className="absolute left-16 top-1/2 -translate-y-1/2 whitespace-nowrap px-3 py-1.5 rounded-lg glass border border-white/15 text-xs text-slate-200 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
      Chat on WhatsApp
    </span>
  </motion.a>
);
